module.exports = __webpack_public_path__ + "img/html-evolution-12.a8068252.webp";